const trimEdgeWhitespace = (el: Element) => {
  if (
    el.firstChild?.nodeType === Node.TEXT_NODE &&
    el.firstChild.nextSibling?.nodeType === Node.ELEMENT_NODE &&
    el.firstChild.nodeValue?.trim() === ''
  ) {
    el.firstChild.remove()
  }

  if (
    el.lastChild?.nodeType === Node.TEXT_NODE &&
    el.lastChild.previousSibling?.nodeType === Node.ELEMENT_NODE &&
    el.lastChild.nodeValue?.trim() === ''
  ) {
    el.lastChild.remove()
  }

  for (const childEl of el.children) {
    trimEdgeWhitespace(childEl)
  }
}

export default function htmlToText(
  str?: string | null,
  options?: {
    isTrim?: boolean
    isCollapseWhitespace?: boolean
  }
): string {
  if (!str) return ''

  const div = document.createElement('div')

  div.innerHTML = str

  trimEdgeWhitespace(div)

  let text = div.innerText

  if (options?.isCollapseWhitespace) {
    text = text.replace(/\s+/g, ' ')
  }

  if (options?.isTrim) {
    text = text.trim()
  }

  return !text &&
    !options?.isTrim &&
    div.querySelectorAll('ul, ol, li').length > 1
    ? ' '
    : text
}
